function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller } from "@hotwired/stimulus";
import CableReady, { Utils } from "cable_ready";
import { createConsumer } from "@rails/actioncable";

/*!
 * Toastify js 1.12.0
 * https://github.com/apvarun/toastify-js
 * @license MIT licensed
 *
 * Copyright (C) 2018 Varun A P
 */
var Toastify = /*#__PURE__*/function () {
  function Toastify(options) {
    _classCallCheck(this, Toastify);
    this.defaults = {
      oldestFirst: true,
      text: "Toastify is awesome!",
      node: undefined,
      duration: 3e3,
      selector: undefined,
      callback: function callback() {},
      destination: undefined,
      newWindow: false,
      close: false,
      gravity: "toastify-top",
      positionLeft: false,
      position: "",
      backgroundColor: "",
      avatar: "",
      className: "",
      stopOnFocus: true,
      onClick: function onClick() {},
      offset: {
        x: 0,
        y: 0
      },
      escapeMarkup: true,
      ariaLive: "polite",
      style: {
        background: ""
      }
    };
    this.version = "1.12.0";
    this.options = {};
    this.toastElement = null;
    this._rootElement = document.body;
    this._init(options);
  }
  _createClass(Toastify, [{
    key: "showToast",
    value: function showToast() {
      var _this = this;
      this.toastElement = this._buildToast();
      if (typeof this.options.selector === "string") {
        this._rootElement = document.getElementById(this.options.selector);
      } else if (this.options.selector instanceof HTMLElement || this.options.selector instanceof ShadowRoot) {
        this._rootElement = this.options.selector;
      } else {
        this._rootElement = document.body;
      }
      if (!this._rootElement) {
        throw "Root element is not defined";
      }
      this._rootElement.insertBefore(this.toastElement, this._rootElement.firstChild);
      this._reposition();
      if (this.options.duration > 0) {
        this.toastElement.timeOutValue = window.setTimeout(function () {
          _this._removeElement(_this.toastElement);
        }, this.options.duration);
      }
      return this;
    }
  }, {
    key: "hideToast",
    value: function hideToast() {
      if (this.toastElement.timeOutValue) {
        clearTimeout(this.toastElement.timeOutValue);
      }
      this._removeElement(this.toastElement);
    }
  }, {
    key: "_init",
    value: function _init(options) {
      this.options = Object.assign(this.defaults, options);
      if (this.options.backgroundColor) {
        console.warn('DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.');
      }
      this.toastElement = null;
      this.options.gravity = options.gravity === "bottom" ? "toastify-bottom" : "toastify-top";
      this.options.stopOnFocus = options.stopOnFocus === undefined ? true : options.stopOnFocus;
      if (options.backgroundColor) {
        this.options.style.background = options.backgroundColor;
      }
    }
  }, {
    key: "_buildToast",
    value: function _buildToast() {
      var _this2 = this;
      if (!this.options) {
        throw "Toastify is not initialized";
      }
      var divElement = document.createElement("div");
      divElement.className = "toastify on ".concat(this.options.className);
      divElement.className += " toastify-".concat(this.options.position);
      divElement.className += " ".concat(this.options.gravity);
      for (var property in this.options.style) {
        divElement.style[property] = this.options.style[property];
      }
      if (this.options.ariaLive) {
        divElement.setAttribute("aria-live", this.options.ariaLive);
      }
      if (this.options.node && this.options.node.nodeType === Node.ELEMENT_NODE) {
        divElement.appendChild(this.options.node);
      } else {
        if (this.options.escapeMarkup) {
          divElement.innerText = this.options.text;
        } else {
          divElement.innerHTML = this.options.text;
        }
        if (this.options.avatar !== "") {
          var avatarElement = document.createElement("img");
          avatarElement.src = this.options.avatar;
          avatarElement.className = "toastify-avatar";
          if (this.options.position == "left") {
            divElement.appendChild(avatarElement);
          } else {
            divElement.insertAdjacentElement("afterbegin", avatarElement);
          }
        }
      }
      if (this.options.close === true) {
        var closeElement = document.createElement("button");
        closeElement.type = "button";
        closeElement.setAttribute("aria-label", "Close");
        closeElement.className = "toast-close";
        closeElement.innerHTML = "&#10006;";
        closeElement.addEventListener("click", function (event) {
          event.stopPropagation();
          _this2._removeElement(_this2.toastElement);
          window.clearTimeout(_this2.toastElement.timeOutValue);
        });
        var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
        if (this.options.position == "left" && width > 360) {
          divElement.insertAdjacentElement("afterbegin", closeElement);
        } else {
          divElement.appendChild(closeElement);
        }
      }
      if (this.options.stopOnFocus && this.options.duration > 0) {
        divElement.addEventListener("mouseover", function (event) {
          window.clearTimeout(divElement.timeOutValue);
        });
        divElement.addEventListener("mouseleave", function () {
          divElement.timeOutValue = window.setTimeout(function () {
            _this2._removeElement(divElement);
          }, _this2.options.duration);
        });
      }
      if (typeof this.options.destination !== "undefined") {
        divElement.addEventListener("click", function (event) {
          event.stopPropagation();
          if (_this2.options.newWindow === true) {
            window.open(_this2.options.destination, "_blank");
          } else {
            window.location = _this2.options.destination;
          }
        });
      }
      if (typeof this.options.onClick === "function" && typeof this.options.destination === "undefined") {
        divElement.addEventListener("click", function (event) {
          event.stopPropagation();
          _this2.options.onClick();
        });
      }
      if (_typeof(this.options.offset) === "object") {
        var x = this._getAxisOffsetAValue("x", this.options);
        var y = this._getAxisOffsetAValue("y", this.options);
        var xOffset = this.options.position == "left" ? x : "-".concat(x);
        var yOffset = this.options.gravity == "toastify-top" ? y : "-".concat(y);
        divElement.style.transform = "translate(".concat(xOffset, ",").concat(yOffset, ")");
      }
      return divElement;
    }
  }, {
    key: "_removeElement",
    value: function _removeElement(toastElement) {
      var _this3 = this;
      toastElement.className = toastElement.className.replace(" on", "");
      window.setTimeout(function () {
        if (_this3.options.node && _this3.options.node.parentNode) {
          _this3.options.node.parentNode.removeChild(_this3.options.node);
        }
        if (toastElement.parentNode) {
          toastElement.parentNode.removeChild(toastElement);
        }
        _this3.options.callback.call(toastElement);
        _this3._reposition();
      }, 400);
    }
  }, {
    key: "_reposition",
    value: function _reposition() {
      var topLeftOffsetSize = {
        top: 15,
        bottom: 15
      };
      var topRightOffsetSize = {
        top: 15,
        bottom: 15
      };
      var offsetSize = {
        top: 15,
        bottom: 15
      };
      var allToasts = this._rootElement.querySelectorAll(".toastify");
      var classUsed;
      for (var i = 0; i < allToasts.length; i++) {
        if (allToasts[i].classList.contains("toastify-top") === true) {
          classUsed = "toastify-top";
        } else {
          classUsed = "toastify-bottom";
        }
        var height = allToasts[i].offsetHeight;
        classUsed = classUsed.substr(9, classUsed.length - 1);
        var offset = 15;
        var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
        if (width <= 360) {
          allToasts[i].style[classUsed] = "".concat(offsetSize[classUsed], "px");
          offsetSize[classUsed] += height + offset;
        } else {
          if (allToasts[i].classList.contains("toastify-left") === true) {
            allToasts[i].style[classUsed] = "".concat(topLeftOffsetSize[classUsed], "px");
            topLeftOffsetSize[classUsed] += height + offset;
          } else {
            allToasts[i].style[classUsed] = "".concat(topRightOffsetSize[classUsed], "px");
            topRightOffsetSize[classUsed] += height + offset;
          }
        }
      }
    }
  }, {
    key: "_getAxisOffsetAValue",
    value: function _getAxisOffsetAValue(axis, options) {
      if (options.offset[axis]) {
        if (isNaN(options.offset[axis])) {
          return options.offset[axis];
        } else {
          return "".concat(options.offset[axis], "px");
        }
      }
      return "0px";
    }
  }]);
  return Toastify;
}();
function StartToastifyInstance(options) {
  return new Toastify(options);
}
CableReady.operations.stimulusReflexVersionMismatch = function (operation) {
  var levels = {
    info: {},
    success: {
      background: "#198754",
      color: "white"
    },
    warn: {
      background: "#ffc107",
      color: "black"
    },
    error: {
      background: "#dc3545",
      color: "white"
    }
  };
  var defaults = {
    selector: setupToastify(),
    close: true,
    duration: 30 * 1e3,
    gravity: "bottom",
    position: "right",
    newWindow: true,
    style: levels[operation.level || "info"]
  };
  StartToastifyInstance(_objectSpread(_objectSpread({}, defaults), operation)).showToast();
};
function setupToastify() {
  var id = "stimulus-reflex-toast-element";
  var element = document.querySelector("#".concat(id));
  if (!element) {
    element = document.createElement("div");
    element.id = id;
    document.documentElement.appendChild(element);
    var styles = document.createElement("style");
    styles.innerHTML = "\n      #".concat(id, " .toastify {\n         padding: 12px 20px;\n         color: #ffffff;\n         display: inline-block;\n         background: -webkit-linear-gradient(315deg, #73a5ff, #5477f5);\n         background: linear-gradient(135deg, #73a5ff, #5477f5);\n         position: fixed;\n         opacity: 0;\n         transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\n         border-radius: 2px;\n         cursor: pointer;\n         text-decoration: none;\n         max-width: calc(50% - 20px);\n         z-index: 2147483647;\n         bottom: -150px;\n         right: 15px;\n      }\n\n      #").concat(id, " .toastify.on {\n        opacity: 1;\n      }\n\n      #").concat(id, " .toast-close {\n        background: transparent;\n        border: 0;\n        color: white;\n        cursor: pointer;\n        font-family: inherit;\n        font-size: 1em;\n        opacity: 0.4;\n        padding: 0 5px;\n      }\n    ");
    document.head.appendChild(styles);
  }
  return element;
}
var deprecationWarnings = true;
var Deprecate = {
  get enabled() {
    return deprecationWarnings;
  },
  get disabled() {
    return !deprecationWarnings;
  },
  get value() {
    return deprecationWarnings;
  },
  set: function set(value) {
    deprecationWarnings = !!value;
  },
  set deprecate(value) {
    deprecationWarnings = !!value;
  }
};
var debugging = false;
var Debug$1 = {
  get enabled() {
    return debugging;
  },
  get disabled() {
    return !debugging;
  },
  get value() {
    return debugging;
  },
  set: function set(value) {
    debugging = !!value;
  },
  set debug(value) {
    debugging = !!value;
  }
};
var defaultSchema = {
  reflexAttribute: "data-reflex",
  reflexPermanentAttribute: "data-reflex-permanent",
  reflexRootAttribute: "data-reflex-root",
  reflexSuppressLoggingAttribute: "data-reflex-suppress-logging",
  reflexDatasetAttribute: "data-reflex-dataset",
  reflexDatasetAllAttribute: "data-reflex-dataset-all",
  reflexSerializeFormAttribute: "data-reflex-serialize-form",
  reflexFormSelectorAttribute: "data-reflex-form-selector",
  reflexIncludeInnerHtmlAttribute: "data-reflex-include-inner-html",
  reflexIncludeTextContentAttribute: "data-reflex-include-text-content"
};
var schema = {};
var Schema = {
  set: function set(application) {
    var _this4 = this;
    schema = _objectSpread(_objectSpread({}, defaultSchema), application.schema);
    var _loop = function _loop(attribute) {
      var attributeName = attribute.slice(0, -9);
      Object.defineProperty(_this4, attributeName, {
        get: function get() {
          return schema[attribute];
        },
        configurable: true
      });
    };
    for (var attribute in schema) {
      _loop(attribute);
    }
  }
};
var debounce = Utils.debounce,
  dispatch = Utils.dispatch,
  xpathToElement = Utils.xpathToElement,
  xpathToElementArray = Utils.xpathToElementArray;
var uuidv4 = function uuidv4() {
  var crypto = window.crypto || window.msCrypto;
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
};
var serializeForm = function serializeForm(form) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!form) return "";
  var w = options.w || window;
  var element = options.element;
  var formData = new w.FormData(form);
  var data = Array.from(formData, function (e) {
    return e.map(encodeURIComponent).join("=");
  });
  var submitButton = form.querySelector("input[type=submit]");
  if (element && element.name && element.nodeName === "INPUT" && element.type === "submit") {
    data.push("".concat(encodeURIComponent(element.name), "=").concat(encodeURIComponent(element.value)));
  } else if (submitButton && submitButton.name) {
    data.push("".concat(encodeURIComponent(submitButton.name), "=").concat(encodeURIComponent(submitButton.value)));
  }
  return Array.from(data).join("&");
};
var camelize = function camelize(value) {
  var uppercaseFirstLetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (typeof value !== "string") return "";
  value = value.replace(/[\s_](.)/g, function ($1) {
    return $1.toUpperCase();
  }).replace(/[\s_]/g, "").replace(/^(.)/, function ($1) {
    return $1.toLowerCase();
  });
  if (uppercaseFirstLetter) value = value.substr(0, 1).toUpperCase() + value.substr(1);
  return value;
};
var XPathToElement = xpathToElement;
var XPathToArray = xpathToElementArray;
var emitEvent = function emitEvent(name) {
  var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return dispatch(document, name, detail);
};
var extractReflexName = function extractReflexName(reflexString) {
  var match = reflexString.match(/(?:.*->)?(.*?)(?:Reflex)?#/);
  return match ? match[1] : "";
};
var elementToXPath = function elementToXPath(element) {
  if (element.id !== "") return "//*[@id='" + element.id + "']";
  if (element === document.body) return "/html/body";
  if (element.nodeName === "HTML") return "/html";
  var ix = 0;
  var siblings = element && element.parentNode ? element.parentNode.childNodes : [];
  for (var i = 0; i < siblings.length; i++) {
    var sibling = siblings[i];
    if (sibling === element) {
      var computedPath = elementToXPath(element.parentNode);
      var tagName = element.tagName.toLowerCase();
      var ixInc = ix + 1;
      return "".concat(computedPath, "/").concat(tagName, "[").concat(ixInc, "]");
    }
    if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
      ix++;
    }
  }
};
var elementInvalid = function elementInvalid(element) {
  return element.type === "number" && element.validity && element.validity.badInput;
};
var getReflexElement = function getReflexElement(args, element) {
  return args[0] && args[0].nodeType === Node.ELEMENT_NODE ? args.shift() : element;
};
var getReflexOptions = function getReflexOptions(args) {
  var options = {};
  if (args[0] && _typeof(args[0]) === "object" && Object.keys(args[0]).filter(function (key) {
    return ["id", "attrs", "selectors", "reflexId", "resolveLate", "serializeForm", "suppressLogging", "includeInnerHTML", "includeTextContent"].includes(key);
  }).length) {
    var opts = args.shift();
    Object.keys(opts).forEach(function (o) {
      if (o === "reflexId") {
        if (Deprecate.enabled) console.warn("reflexId option will be removed in v4. Use id instead.");
        options["id"] = opts["reflexId"];
      } else options[o] = opts[o];
    });
  }
  return options;
};
var getReflexRoots = function getReflexRoots(element) {
  var list = [];
  while (list.length === 0 && element) {
    var reflexRoot = element.getAttribute(Schema.reflexRoot);
    if (reflexRoot) {
      if (reflexRoot.length === 0 && element.id) reflexRoot = "#".concat(element.id);
      var selectors = reflexRoot.split(",").filter(function (s) {
        return s.trim().length;
      });
      if (Debug$1.enabled && selectors.length === 0) {
        console.error("No value found for ".concat(Schema.reflexRoot, ". Add an #id to the element or provide a value for ").concat(Schema.reflexRoot, "."), element);
      }
      list = list.concat(selectors.filter(function (s) {
        return document.querySelector(s);
      }));
    }
    element = element.parentElement ? element.parentElement.closest("[".concat(Schema.reflexRoot, "]")) : null;
  }
  return list;
};
var reflexNameToControllerIdentifier = function reflexNameToControllerIdentifier(reflexName) {
  return reflexName.replace(/([a-z0–9])([A-Z])/g, "$1-$2").replace(/(::)/g, "--").replace(/-reflex$/gi, "").toLowerCase();
};
var stages = ["created", "before", "delivered", "queued", "after", "finalized", "success", "error", "halted", "forbidden"];
var lastReflex;
var reflexes = new Proxy({}, {
  get: function get(target, prop) {
    if (stages.includes(prop)) return Object.fromEntries(Object.entries(target).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        _ = _ref2[0],
        reflex = _ref2[1];
      return reflex.stage === prop;
    }));else if (prop === "last") return lastReflex;else if (prop === "all") return target;
    return Reflect.get.apply(Reflect, arguments);
  },
  set: function set(target, prop, value) {
    target[prop] = value;
    lastReflex = value;
    return true;
  }
});
var invokeLifecycleMethod = function invokeLifecycleMethod(reflex, stage) {
  var specificLifecycleMethod = reflex.controller[["before", "after", "finalize"].includes(stage) ? "".concat(stage).concat(camelize(reflex.action)) : "".concat(camelize(reflex.action, false)).concat(camelize(stage))];
  var genericLifecycleMethod = reflex.controller[["before", "after", "finalize"].includes(stage) ? "".concat(stage, "Reflex") : "reflex".concat(camelize(stage))];
  if (typeof specificLifecycleMethod === "function") {
    specificLifecycleMethod.call(reflex.controller, reflex.element, reflex.target, reflex.error, reflex.id, reflex.payload);
  }
  if (typeof genericLifecycleMethod === "function") {
    genericLifecycleMethod.call(reflex.controller, reflex.element, reflex.target, reflex.error, reflex.id, reflex.payload);
  }
};
var dispatchLifecycleEvent = function dispatchLifecycleEvent(reflex, stage) {
  if (!reflex.controller.element.parentElement) {
    if (Debug$1.enabled && !reflex.warned) {
      console.warn("StimulusReflex was not able execute callbacks or emit events for \"".concat(stage, "\" or later life-cycle stages for this Reflex. The StimulusReflex Controller Element is no longer present in the DOM. Could you move the StimulusReflex Controller to an element higher in your DOM?"));
      reflex.warned = true;
    }
    return;
  }
  reflex.stage = stage;
  reflex.lifecycle.push(stage);
  var event = "stimulus-reflex:".concat(stage);
  var action = "".concat(event, ":").concat(reflex.action);
  var detail = {
    reflex: reflex.target,
    controller: reflex.controller,
    id: reflex.id,
    element: reflex.element,
    payload: reflex.payload
  };
  var options = {
    bubbles: true,
    cancelable: false,
    detail: detail
  };
  reflex.controller.element.dispatchEvent(new CustomEvent(event, options));
  reflex.controller.element.dispatchEvent(new CustomEvent(action, options));
  if (window.jQuery) {
    window.jQuery(reflex.controller.element).trigger(event, detail);
    window.jQuery(reflex.controller.element).trigger(action, detail);
  }
};
document.addEventListener("stimulus-reflex:before", function (event) {
  return invokeLifecycleMethod(reflexes[event.detail.id], "before");
}, true);
document.addEventListener("stimulus-reflex:queued", function (event) {
  return invokeLifecycleMethod(reflexes[event.detail.id], "queued");
}, true);
document.addEventListener("stimulus-reflex:delivered", function (event) {
  return invokeLifecycleMethod(reflexes[event.detail.id], "delivered");
}, true);
document.addEventListener("stimulus-reflex:success", function (event) {
  var reflex = reflexes[event.detail.id];
  invokeLifecycleMethod(reflex, "success");
  dispatchLifecycleEvent(reflex, "after");
}, true);
document.addEventListener("stimulus-reflex:nothing", function (event) {
  return dispatchLifecycleEvent(reflexes[event.detail.id], "success");
}, true);
document.addEventListener("stimulus-reflex:error", function (event) {
  var reflex = reflexes[event.detail.id];
  invokeLifecycleMethod(reflex, "error");
  dispatchLifecycleEvent(reflex, "after");
}, true);
document.addEventListener("stimulus-reflex:halted", function (event) {
  return invokeLifecycleMethod(reflexes[event.detail.id], "halted");
}, true);
document.addEventListener("stimulus-reflex:forbidden", function (event) {
  return invokeLifecycleMethod(reflexes[event.detail.id], "forbidden");
}, true);
document.addEventListener("stimulus-reflex:after", function (event) {
  return invokeLifecycleMethod(reflexes[event.detail.id], "after");
}, true);
document.addEventListener("stimulus-reflex:finalize", function (event) {
  return invokeLifecycleMethod(reflexes[event.detail.id], "finalize");
}, true);
var app = {};
var App = {
  get app() {
    return app;
  },
  set: function set(application) {
    app = application;
  }
};
var isolationMode = false;
var IsolationMode = {
  get disabled() {
    return !isolationMode;
  },
  set: function set(value) {
    isolationMode = value;
    if (Deprecate.enabled && !isolationMode) {
      document.addEventListener("DOMContentLoaded", function () {
        return console.warn("Deprecation warning: the next version of StimulusReflex will standardize isolation mode, and the isolate option will be removed.\nPlease update your applications to assume that every tab will be isolated. Use CableReady operations to broadcast updates to other tabs and users.");
      }, {
        once: true
      });
    }
  }
};
var Reflex = /*#__PURE__*/function () {
  function Reflex(data, controller) {
    _classCallCheck(this, Reflex);
    this.data = data.valueOf();
    this.controller = controller;
    this.element = data.reflexElement;
    this.id = data.id;
    this.error = null;
    this.payload = null;
    this.stage = "created";
    this.lifecycle = ["created"];
    this.warned = false;
    this.target = data.target;
    this.action = data.target.split("#")[1];
    this.selector = null;
    this.morph = null;
    this.operation = null;
    this.timestamp = new Date();
    this.cloned = false;
  }
  _createClass(Reflex, [{
    key: "getPromise",
    get: function get() {
      var _this5 = this;
      var promise = new Promise(function (resolve, reject) {
        _this5.promise = {
          resolve: resolve,
          reject: reject,
          data: _this5.data
        };
      });
      promise.id = this.id;
      Object.defineProperty(promise, "reflexId", {
        get: function get() {
          if (Deprecate.enabled) console.warn("reflexId is deprecated and will be removed from v4. Use id instead.");
          return this.id;
        }
      });
      promise.reflex = this;
      if (Debug$1.enabled) promise.catch(function () {});
      return promise;
    }
  }]);
  return Reflex;
}();
var received = function received(data) {
  if (!data.cableReady) return;
  if (data.version.replace(".pre", "-pre").replace(".rc", "-rc") !== CableReady.version) {
    var mismatch = "CableReady failed to execute your reflex action due to a version mismatch between your gem and JavaScript version. Package versions must match exactly.\n\ncable_ready gem: ".concat(data.version, "\ncable_ready npm: ").concat(CableReady.version);
    console.error(mismatch);
    if (Debug$1.enabled) {
      CableReady.operations.stimulusReflexVersionMismatch({
        text: mismatch,
        level: "error"
      });
    }
    return;
  }
  var reflexOperations = [];
  for (var i = data.operations.length - 1; i >= 0; i--) {
    if (data.operations[i].stimulusReflex) {
      reflexOperations.push(data.operations[i]);
      data.operations.splice(i, 1);
    }
  }
  if (reflexOperations.some(function (operation) {
    return operation.stimulusReflex.url !== location.href;
  })) {
    if (Debug$1.enabled) {
      console.error("Reflex failed due to mismatched URL.");
      return;
    }
  }
  var reflexData;
  if (reflexOperations.length) {
    reflexData = reflexOperations[0].stimulusReflex;
    reflexData.payload = reflexOperations[0].payload;
  }
  if (reflexData) {
    var _reflexData = reflexData,
      id = _reflexData.id,
      payload = _reflexData.payload;
    var reflex;
    if (!reflexes[id] && IsolationMode.disabled) {
      var controllerElement = XPathToElement(reflexData.xpathController);
      var reflexElement = XPathToElement(reflexData.xpathElement);
      controllerElement.reflexController = controllerElement.reflexController || {};
      controllerElement.reflexData = controllerElement.reflexData || {};
      controllerElement.reflexError = controllerElement.reflexError || {};
      var controller = App.app.getControllerForElementAndIdentifier(controllerElement, reflexData.reflexController);
      controllerElement.reflexController[id] = controller;
      controllerElement.reflexData[id] = reflexData;
      reflex = new Reflex(reflexData, controller);
      reflexes[id] = reflex;
      reflex.cloned = true;
      reflex.element = reflexElement;
      controller.lastReflex = reflex;
      dispatchLifecycleEvent(reflex, "before");
      reflex.getPromise;
    } else {
      reflex = reflexes[id];
    }
    if (reflex) {
      reflex.payload = payload;
      reflex.totalOperations = reflexOperations.length;
      reflex.pendingOperations = reflexOperations.length;
      reflex.completedOperations = 0;
      reflex.piggybackOperations = data.operations;
      CableReady.perform(reflexOperations);
    }
  } else {
    if (data.operations.length && reflexes[data.operations[0].reflexId]) {
      CableReady.perform(data.operations);
    }
  }
};
var consumer;
var params;
var subscription;
var active;
var initialize$1 = function initialize$1(consumerValue, paramsValue) {
  consumer = consumerValue;
  params = paramsValue;
  document.addEventListener("DOMContentLoaded", function () {
    active = false;
    connectionStatusClass();
    if (Deprecate.enabled && consumerValue) console.warn("Deprecation warning: the next version of StimulusReflex will obtain a reference to consumer via the Stimulus application object.\nPlease add 'application.consumer = consumer' to your index.js after your Stimulus application has been established, and remove the consumer key from your StimulusReflex initialize() options object.");
  });
  document.addEventListener("turbolinks:load", connectionStatusClass);
  document.addEventListener("turbo:load", connectionStatusClass);
};
var subscribe = function subscribe(controller) {
  if (subscription) return;
  consumer = consumer || controller.application.consumer || createConsumer();
  var channel = controller.StimulusReflex.channel;
  var request = _objectSpread({
    channel: channel
  }, params);
  var identifier = JSON.stringify(request);
  subscription = consumer.subscriptions.findAll(identifier)[0] || consumer.subscriptions.create(request, {
    received: received,
    connected: connected,
    rejected: rejected,
    disconnected: disconnected
  });
};
var connected = function connected() {
  active = true;
  connectionStatusClass();
  emitEvent("stimulus-reflex:connected");
  Object.values(reflexes.queued).forEach(function (reflex) {
    subscription.send(reflex.data);
    dispatchLifecycleEvent(reflex, "delivered");
  });
};
var rejected = function rejected() {
  active = false;
  connectionStatusClass();
  emitEvent("stimulus-reflex:rejected");
  if (Debug.enabled) console.warn("Channel subscription was rejected.");
};
var disconnected = function disconnected(willAttemptReconnect) {
  active = false;
  connectionStatusClass();
  emitEvent("stimulus-reflex:disconnected", willAttemptReconnect);
};
var deliver = function deliver(reflex) {
  if (active) {
    subscription.send(reflex.data);
    dispatchLifecycleEvent(reflex, "delivered");
  } else dispatchLifecycleEvent(reflex, "queued");
};
var connectionStatusClass = function connectionStatusClass() {
  var list = document.body.classList;
  if (!(list.contains("stimulus-reflex-connected") || list.contains("stimulus-reflex-disconnected"))) {
    list.add(active ? "stimulus-reflex-connected" : "stimulus-reflex-disconnected");
    return;
  }
  if (active) {
    list.replace("stimulus-reflex-disconnected", "stimulus-reflex-connected");
  } else {
    list.replace("stimulus-reflex-connected", "stimulus-reflex-disconnected");
  }
};
var ActionCableTransport = {
  subscribe: subscribe,
  deliver: deliver,
  initialize: initialize$1
};
var request = function request(reflex) {
  if (Debug$1.disabled || reflex.data.suppressLogging) return;
  console.log("\u2191 stimulus \u2191 ".concat(reflex.target), {
    id: reflex.id,
    args: reflex.data.args,
    controller: reflex.controller.identifier,
    element: reflex.element,
    controllerElement: reflex.controller.element
  });
};
var success = function success(reflex) {
  if (Debug$1.disabled || reflex.data.suppressLogging) return;
  var output = {
    id: reflex.id,
    morph: reflex.morph,
    payload: reflex.payload
  };
  if (reflex.operation !== "dispatch_event") output.operation = reflex.operation;
  console.log("\u2193 reflex \u2193 ".concat(reflex.target, " \u2192 ").concat(reflex.selector || "∞").concat(progress(reflex), " ").concat(duration(reflex)), output);
};
var halted$1 = function halted$1(reflex) {
  if (Debug$1.disabled || reflex.data.suppressLogging) return;
  console.log("\u2193 reflex \u2193 ".concat(reflex.target, " ").concat(duration(reflex), " %cHALTED"), "color: #ffa500;", {
    id: reflex.id,
    payload: reflex.payload
  });
};
var forbidden$1 = function forbidden$1(reflex) {
  if (Debug$1.disabled || reflex.data.suppressLogging) return;
  console.log("\u2193 reflex \u2193 ".concat(reflex.target, " ").concat(duration(reflex), " %cFORBIDDEN"), "color: #BF40BF;", {
    id: reflex.id,
    payload: reflex.payload
  });
};
var error$1 = function error$1(reflex) {
  if (Debug$1.disabled || reflex.data.suppressLogging) return;
  console.log("\u2193 reflex \u2193 ".concat(reflex.target, " ").concat(duration(reflex), " %cERROR: ").concat(reflex.error), "color: #f00;", {
    id: reflex.id,
    payload: reflex.payload
  });
};
var duration = function duration(reflex) {
  return !reflex.cloned ? "in ".concat(new Date() - reflex.timestamp, "ms") : "CLONED";
};
var progress = function progress(reflex) {
  return reflex.totalOperations > 1 ? " ".concat(reflex.completedOperations, "/").concat(reflex.totalOperations) : "";
};
var Log = {
  request: request,
  success: success,
  halted: halted$1,
  forbidden: forbidden$1,
  error: error$1
};
var multipleInstances = function multipleInstances(element) {
  if (["checkbox", "radio"].includes(element.type)) {
    return document.querySelectorAll("input[type=\"".concat(element.type, "\"][name=\"").concat(element.name, "\"]")).length > 1;
  }
  return false;
};
var collectCheckedOptions = function collectCheckedOptions(element) {
  return Array.from(element.querySelectorAll("option:checked")).concat(Array.from(document.querySelectorAll("input[type=\"".concat(element.type, "\"][name=\"").concat(element.name, "\"]"))).filter(function (elem) {
    return elem.checked;
  })).map(function (o) {
    return o.value;
  });
};
var attributeValue = function attributeValue() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = Array.from(new Set(values.filter(function (v) {
    return v && String(v).length;
  }).map(function (v) {
    return v.trim();
  }))).join(" ").trim();
  return value.length > 0 ? value : null;
};
var attributeValues = function attributeValues(value) {
  if (!value) return [];
  if (!value.length) return [];
  return value.split(" ").filter(function (v) {
    return v.trim().length;
  });
};
var extractElementAttributes = function extractElementAttributes(element) {
  var attrs = Array.from(element.attributes).reduce(function (memo, attr) {
    memo[attr.name] = attr.value;
    return memo;
  }, {});
  attrs.checked = !!element.checked;
  attrs.selected = !!element.selected;
  attrs.tag_name = element.tagName;
  if (element.tagName.match(/select/i) || multipleInstances(element)) {
    var collectedOptions = collectCheckedOptions(element);
    attrs.values = collectedOptions;
    attrs.value = collectedOptions.join(",");
  } else {
    attrs.value = element.value;
  }
  return attrs;
};
var getElementsFromTokens = function getElementsFromTokens(element, tokens) {
  if (!tokens || tokens.length === 0) return [];
  var elements = [element];
  var xPath = elementToXPath(element);
  tokens.forEach(function (token) {
    try {
      switch (token) {
        case "combined":
          if (Deprecate.enabled) console.warn("In the next version of StimulusReflex, the 'combined' option to data-reflex-dataset will become 'ancestors'.");
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/ancestor::*"), true)));
          break;
        case "ancestors":
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/ancestor::*"), true)));
          break;
        case "parent":
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/parent::*"))));
          break;
        case "siblings":
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/preceding-sibling::*|").concat(xPath, "/following-sibling::*"))));
          break;
        case "children":
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/child::*"))));
          break;
        case "descendants":
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(XPathToArray("".concat(xPath, "/descendant::*"))));
          break;
        default:
          elements = [].concat(_toConsumableArray(elements), _toConsumableArray(document.querySelectorAll(token)));
      }
    } catch (error) {
      if (Debug$1.enabled) console.error(error);
    }
  });
  return elements;
};
var extractElementDataset = function extractElementDataset(element) {
  var dataset = element.attributes[Schema.reflexDataset];
  var allDataset = element.attributes[Schema.reflexDatasetAll];
  var tokens = dataset && dataset.value.split(" ") || [];
  var allTokens = allDataset && allDataset.value.split(" ") || [];
  var datasetElements = getElementsFromTokens(element, tokens);
  var datasetAllElements = getElementsFromTokens(element, allTokens);
  var datasetAttributes = datasetElements.reduce(function (acc, ele) {
    return _objectSpread(_objectSpread({}, extractDataAttributes(ele)), acc);
  }, {});
  var reflexElementAttributes = extractDataAttributes(element);
  var elementDataset = {
    dataset: _objectSpread(_objectSpread({}, reflexElementAttributes), datasetAttributes),
    datasetAll: {}
  };
  datasetAllElements.forEach(function (element) {
    var elementAttributes = extractDataAttributes(element);
    Object.keys(elementAttributes).forEach(function (key) {
      var value = elementAttributes[key];
      if (elementDataset.datasetAll[key] && Array.isArray(elementDataset.datasetAll[key])) {
        elementDataset.datasetAll[key].push(value);
      } else {
        elementDataset.datasetAll[key] = [value];
      }
    });
  });
  return elementDataset;
};
var extractDataAttributes = function extractDataAttributes(element) {
  var attrs = {};
  if (element && element.attributes) {
    Array.from(element.attributes).forEach(function (attr) {
      if (attr.name.startsWith("data-")) {
        attrs[attr.name] = attr.value;
      }
    });
  }
  return attrs;
};
var name = "stimulus_reflex";
var version = "3.5.5";
var description = "Build reactive applications with the Rails tooling you already know and love.";
var keywords = ["ruby", "rails", "websockets", "actioncable", "turbolinks", "reactive", "cable", "ujs", "ssr", "stimulus", "reflex", "stimulus_reflex", "dom", "morphdom"];
var homepage = "https://docs.stimulusreflex.com";
var bugs = "https://github.com/stimulusreflex/stimulus_reflex/issues";
var repository = "https://github.com/stimulusreflex/stimulus_reflex";
var license = "MIT";
var author = "Nathan Hopkins <natehop@gmail.com>";
var contributors = ["Andrew Mason <andrewmcodes@protonmail.com>", "Julian Rubisch <julian@julianrubisch.at>", "Marco Roth <marco.roth@intergga.ch>", "Nathan Hopkins <natehop@gmail.com>"];
var main = "./dist/stimulus_reflex.js";
var module = "./dist/stimulus_reflex.js";
var browser = "./dist/stimulus_reflex.js";
var unpkg = "./dist/stimulus_reflex.umd.js";
var umd = "./dist/stimulus_reflex.umd.js";
var files = ["dist/*", "javascript/*"];
var scripts = {
  lint: "yarn run format --check",
  format: "yarn run prettier-standard ./javascript/**/*.js rollup.config.mjs",
  build: "yarn rollup -c",
  "build:watch": "yarn rollup -wc",
  watch: "yarn build:watch",
  test: "web-test-runner javascript/test/**/*.test.js",
  "test:watch": "yarn test --watch",
  "docs:dev": "vitepress dev docs",
  "docs:build": "vitepress build docs && cp docs/_redirects docs/.vitepress/dist",
  "docs:preview": "vitepress preview docs"
};
var peerDependencies = {
  "@hotwired/stimulus": ">= 3.0"
};
var dependencies = {
  "@hotwired/stimulus": "^3",
  "@rails/actioncable": "^6 || ^7 || ^8",
  cable_ready: "^5.0.6"
};
var devDependencies = {
  "@open-wc/testing": "^4.0.0",
  "@rollup/plugin-json": "^6.1.0",
  "@rollup/plugin-node-resolve": "^15.3.0",
  "@rollup/plugin-terser": "^0.4.4",
  "@web/dev-server-esbuild": "^1.0.2",
  "@web/dev-server-rollup": "^0.6.4",
  "@web/test-runner": "^0.19.0",
  "prettier-standard": "^16.4.1",
  rollup: "^4.22.4",
  "toastify-js": "^1.12.0",
  vitepress: "^1.0.0-beta.1"
};
var packageInfo = {
  name: name,
  version: version,
  description: description,
  keywords: keywords,
  homepage: homepage,
  bugs: bugs,
  repository: repository,
  license: license,
  author: author,
  contributors: contributors,
  main: main,
  module: module,
  browser: browser,
  import: "./dist/stimulus_reflex.js",
  unpkg: unpkg,
  umd: umd,
  files: files,
  scripts: scripts,
  peerDependencies: peerDependencies,
  dependencies: dependencies,
  devDependencies: devDependencies
};
var ReflexData = /*#__PURE__*/function () {
  function ReflexData(options, reflexElement, controllerElement, reflexController, permanentAttributeName, target, args, url, tabId) {
    _classCallCheck(this, ReflexData);
    this.options = options;
    this.reflexElement = reflexElement;
    this.controllerElement = controllerElement;
    this.reflexController = reflexController;
    this.permanentAttributeName = permanentAttributeName;
    this.target = target;
    this.args = args;
    this.url = url;
    this.tabId = tabId;
  }
  _createClass(ReflexData, [{
    key: "attrs",
    get: function get() {
      this._attrs = this._attrs || this.options["attrs"] || extractElementAttributes(this.reflexElement);
      return this._attrs;
    }
  }, {
    key: "id",
    get: function get() {
      this._id = this._id || this.options["id"] || uuidv4();
      return this._id;
    }
  }, {
    key: "selectors",
    get: function get() {
      this._selectors = this._selectors || this.options["selectors"] || getReflexRoots(this.reflexElement);
      return typeof this._selectors === "string" ? [this._selectors] : this._selectors;
    }
  }, {
    key: "resolveLate",
    get: function get() {
      return this.options["resolveLate"] || false;
    }
  }, {
    key: "dataset",
    get: function get() {
      this._dataset = this._dataset || extractElementDataset(this.reflexElement);
      return this._dataset;
    }
  }, {
    key: "innerHTML",
    get: function get() {
      return this.includeInnerHtml ? this.reflexElement.innerHTML : "";
    }
  }, {
    key: "textContent",
    get: function get() {
      return this.includeTextContent ? this.reflexElement.textContent : "";
    }
  }, {
    key: "xpathController",
    get: function get() {
      return elementToXPath(this.controllerElement);
    }
  }, {
    key: "xpathElement",
    get: function get() {
      return elementToXPath(this.reflexElement);
    }
  }, {
    key: "formSelector",
    get: function get() {
      var attr = this.reflexElement.attributes[Schema.reflexFormSelector] ? this.reflexElement.attributes[Schema.reflexFormSelector].value : undefined;
      return this.options["formSelector"] || attr;
    }
  }, {
    key: "includeInnerHtml",
    get: function get() {
      var attr = this.reflexElement.attributes[Schema.reflexIncludeInnerHtml] || false;
      return this.options["includeInnerHTML"] || attr ? attr.value !== "false" : false;
    }
  }, {
    key: "includeTextContent",
    get: function get() {
      var attr = this.reflexElement.attributes[Schema.reflexIncludeTextContent] || false;
      return this.options["includeTextContent"] || attr ? attr.value !== "false" : false;
    }
  }, {
    key: "suppressLogging",
    get: function get() {
      return this.options["suppressLogging"] || this.reflexElement.attributes[Schema.reflexSuppressLogging] || false;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      return {
        attrs: this.attrs,
        dataset: this.dataset,
        selectors: this.selectors,
        id: this.id,
        resolveLate: this.resolveLate,
        suppressLogging: this.suppressLogging,
        xpathController: this.xpathController,
        xpathElement: this.xpathElement,
        inner_html: this.innerHTML,
        text_content: this.textContent,
        formSelector: this.formSelector,
        reflexController: this.reflexController,
        permanentAttributeName: this.permanentAttributeName,
        target: this.target,
        args: this.args,
        url: this.url,
        tabId: this.tabId,
        version: packageInfo.version
      };
    }
  }]);
  return ReflexData;
}();
var transport = {};
var Transport = {
  get plugin() {
    return transport;
  },
  set: function set(newTransport) {
    transport = newTransport;
  }
};
var beforeDOMUpdate = function beforeDOMUpdate(event) {
  var _ref3 = event.detail || {},
    stimulusReflex = _ref3.stimulusReflex;
  if (!stimulusReflex) return;
  var reflex = reflexes[stimulusReflex.id];
  reflex.pendingOperations--;
  if (reflex.pendingOperations > 0) return;
  if (!stimulusReflex.resolveLate) setTimeout(function () {
    return reflex.promise.resolve({
      element: reflex.element,
      event: event,
      data: reflex.data,
      payload: reflex.payload,
      id: reflex.id,
      toString: function toString() {
        return "";
      }
    });
  });
  setTimeout(function () {
    return dispatchLifecycleEvent(reflex, "success");
  });
};
var afterDOMUpdate = function afterDOMUpdate(event) {
  var _ref4 = event.detail || {},
    stimulusReflex = _ref4.stimulusReflex;
  if (!stimulusReflex) return;
  var reflex = reflexes[stimulusReflex.id];
  reflex.completedOperations++;
  reflex.selector = event.detail.selector;
  reflex.morph = event.detail.stimulusReflex.morph;
  reflex.operation = event.type.split(":")[1].split("-").slice(1).join("_");
  Log.success(reflex);
  if (reflex.completedOperations < reflex.totalOperations) return;
  if (stimulusReflex.resolveLate) setTimeout(function () {
    return reflex.promise.resolve({
      element: reflex.element,
      event: event,
      data: reflex.data,
      payload: reflex.payload,
      id: reflex.id,
      toString: function toString() {
        return "";
      }
    });
  });
  setTimeout(function () {
    return dispatchLifecycleEvent(reflex, "finalize");
  });
  if (reflex.piggybackOperations.length) CableReady.perform(reflex.piggybackOperations);
};
var routeReflexEvent = function routeReflexEvent(event) {
  var _ref5 = event.detail || {},
    stimulusReflex = _ref5.stimulusReflex,
    name = _ref5.name;
  var eventType = name.split("-")[2];
  var eventTypes = {
    nothing: nothing,
    halted: halted,
    forbidden: forbidden,
    error: error
  };
  if (!stimulusReflex || !Object.keys(eventTypes).includes(eventType)) return;
  var reflex = reflexes[stimulusReflex.id];
  reflex.completedOperations++;
  reflex.pendingOperations--;
  reflex.selector = event.detail.selector;
  reflex.morph = event.detail.stimulusReflex.morph;
  reflex.operation = event.type.split(":")[1].split("-").slice(1).join("_");
  if (eventType === "error") reflex.error = event.detail.error;
  eventTypes[eventType](reflex, event);
  setTimeout(function () {
    return dispatchLifecycleEvent(reflex, eventType);
  });
  if (reflex.piggybackOperations.length) CableReady.perform(reflex.piggybackOperations);
};
var nothing = function nothing(reflex, event) {
  Log.success(reflex);
  setTimeout(function () {
    return reflex.promise.resolve({
      data: reflex.data,
      element: reflex.element,
      event: event,
      payload: reflex.payload,
      id: reflex.id,
      toString: function toString() {
        return "";
      }
    });
  });
};
var halted = function halted(reflex, event) {
  Log.halted(reflex, event);
  setTimeout(function () {
    return reflex.promise.resolve({
      data: reflex.data,
      element: reflex.element,
      event: event,
      payload: reflex.payload,
      id: reflex.id,
      toString: function toString() {
        return "";
      }
    });
  });
};
var forbidden = function forbidden(reflex, event) {
  Log.forbidden(reflex, event);
  setTimeout(function () {
    return reflex.promise.resolve({
      data: reflex.data,
      element: reflex.element,
      event: event,
      payload: reflex.payload,
      id: reflex.id,
      toString: function toString() {
        return "";
      }
    });
  });
};
var error = function error(reflex, event) {
  Log.error(reflex, event);
  setTimeout(function () {
    return reflex.promise.reject({
      data: reflex.data,
      element: reflex.element,
      event: event,
      payload: reflex.payload,
      id: reflex.id,
      error: reflex.error,
      toString: function toString() {
        return reflex.error;
      }
    });
  });
};
var localReflexControllers = function localReflexControllers(element) {
  var potentialIdentifiers = attributeValues(element.getAttribute(Schema.controller));
  var potentialControllers = potentialIdentifiers.map(function (identifier) {
    return App.app.getControllerForElementAndIdentifier(element, identifier);
  });
  return potentialControllers.filter(function (controller) {
    return controller && controller.StimulusReflex;
  });
};
var allReflexControllers = function allReflexControllers(element) {
  var controllers = [];
  while (element) {
    controllers = controllers.concat(localReflexControllers(element));
    element = element.parentElement;
  }
  return controllers;
};
var findControllerByReflexName = function findControllerByReflexName(reflexName, controllers) {
  var controller = controllers.find(function (controller) {
    if (!controller || !controller.identifier) return;
    var identifier = reflexNameToControllerIdentifier(extractReflexName(reflexName));
    return identifier === controller.identifier;
  });
  return controller;
};
var scanForReflexes = debounce(function () {
  var reflexElements = document.querySelectorAll("[".concat(Schema.reflex, "]"));
  reflexElements.forEach(function (element) {
    return scanForReflexesOnElement(element);
  });
}, 20);
var scanForReflexesOnElement = function scanForReflexesOnElement(element) {
  var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var controllerAttribute = element.getAttribute(Schema.controller);
  var controllers = attributeValues(controllerAttribute).filter(function (controller) {
    return controller !== "stimulus-reflex";
  });
  var reflexAttribute = element.getAttribute(Schema.reflex);
  var reflexAttributeNames = attributeValues(reflexAttribute);
  var actionAttribute = element.getAttribute(Schema.action);
  var actions = attributeValues(actionAttribute).filter(function (action) {
    return !action.includes("#__perform");
  });
  reflexAttributeNames.forEach(function (reflexName) {
    var potentialControllers = [controller].concat(allReflexControllers(element));
    controller = findControllerByReflexName(reflexName, potentialControllers);
    var controllerName = controller ? controller.identifier : "stimulus-reflex";
    actions.push("".concat(reflexName.split("->")[0], "->").concat(controllerName, "#__perform"));
    var parentControllerElement = element.closest("[data-controller~=".concat(controllerName, "]"));
    var elementPreviouslyHadStimulusReflexController = element === parentControllerElement && controllerName === "stimulus-reflex";
    if (!parentControllerElement || elementPreviouslyHadStimulusReflexController) {
      controllers.push(controllerName);
    }
  });
  var controllerValue = attributeValue(controllers);
  var actionValue = attributeValue(actions);
  var emitReadyEvent = false;
  if (controllerValue && element.getAttribute(Schema.controller) != controllerValue) {
    element.setAttribute(Schema.controller, controllerValue);
    emitReadyEvent = true;
  }
  if (actionValue && element.getAttribute(Schema.action) != actionValue) {
    element.setAttribute(Schema.action, actionValue);
    emitReadyEvent = true;
  }
  if (emitReadyEvent) {
    dispatch(element, "stimulus-reflex:ready", {
      reflex: reflexAttribute,
      controller: controllerValue,
      action: actionValue,
      element: element
    });
  }
};
var StimulusReflexController = /*#__PURE__*/function (_Controller) {
  _inherits(StimulusReflexController, _Controller);
  var _super = _createSuper(StimulusReflexController);
  function StimulusReflexController() {
    var _this6;
    _classCallCheck(this, StimulusReflexController);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this6 = _super.call.apply(_super, [this].concat(args));
    register(_assertThisInitialized(_this6));
    return _this6;
  }
  return _createClass(StimulusReflexController);
}(Controller);
var tabId = uuidv4();
var initialize = function initialize(application) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    controller = _ref6.controller,
    consumer = _ref6.consumer,
    debug = _ref6.debug,
    params = _ref6.params,
    isolate = _ref6.isolate,
    deprecate = _ref6.deprecate,
    transport = _ref6.transport;
  Transport.set(transport || ActionCableTransport);
  Transport.plugin.initialize(consumer, params);
  IsolationMode.set(!!isolate);
  App.set(application);
  Schema.set(application);
  App.app.register("stimulus-reflex", controller || StimulusReflexController);
  Debug$1.set(!!debug);
  if (typeof deprecate !== "undefined") Deprecate.set(deprecate);
  var observer = new MutationObserver(scanForReflexes);
  observer.observe(document.documentElement, {
    attributeFilter: [Schema.reflex, Schema.action],
    childList: true,
    subtree: true
  });
  emitEvent("stimulus-reflex:initialized");
};
var register = function register(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var channel = "StimulusReflex::Channel";
  controller.StimulusReflex = _objectSpread(_objectSpread({}, options), {}, {
    channel: channel
  });
  Transport.plugin.subscribe(controller);
  Object.assign(controller, {
    stimulate: function stimulate() {
      var url = location.href;
      var controllerElement = this.element;
      var args = Array.from(arguments);
      var target = args.shift() || "StimulusReflex::Reflex#default_reflex";
      var reflexElement = getReflexElement(args, controllerElement);
      if (elementInvalid(reflexElement)) {
        if (Debug$1.enabled) console.warn("Reflex aborted: invalid numeric input");
        return;
      }
      var options = getReflexOptions(args);
      var reflexData = new ReflexData(options, reflexElement, controllerElement, this.identifier, Schema.reflexPermanent, target, args, url, tabId);
      var id = reflexData.id;
      controllerElement.reflexController = controllerElement.reflexController || {};
      controllerElement.reflexData = controllerElement.reflexData || {};
      controllerElement.reflexError = controllerElement.reflexError || {};
      controllerElement.reflexController[id] = this;
      controllerElement.reflexData[id] = reflexData.valueOf();
      var reflex = new Reflex(reflexData, this);
      reflexes[id] = reflex;
      this.lastReflex = reflex;
      dispatchLifecycleEvent(reflex, "before");
      setTimeout(function () {
        var _ref7 = controllerElement.reflexData[id] || {},
          params = _ref7.params;
        var check = reflexElement.attributes[Schema.reflexSerializeForm];
        if (check) {
          options["serializeForm"] = check.value !== "false";
        }
        var form = reflexElement.closest(reflexData.formSelector) || document.querySelector(reflexData.formSelector) || reflexElement.closest("form");
        if (Deprecate.enabled && options["serializeForm"] === undefined && form) console.warn("Deprecation warning: the next version of StimulusReflex will not serialize forms by default.\nPlease set ".concat(Schema.reflexSerializeForm, "=\"true\" on your Reflex Controller Element or pass { serializeForm: true } as an option to stimulate."));
        var formData = options["serializeForm"] === false ? "" : serializeForm(form, {
          element: reflexElement
        });
        reflex.data = _objectSpread(_objectSpread({}, reflexData.valueOf()), {}, {
          params: params,
          formData: formData
        });
        controllerElement.reflexData[id] = reflex.data;
        Transport.plugin.deliver(reflex);
      });
      Log.request(reflex);
      return reflex.getPromise;
    },
    __perform: function __perform(event) {
      var element = event.target;
      var reflex;
      while (element && !reflex) {
        reflex = element.getAttribute(Schema.reflex);
        if (!reflex || !reflex.trim().length) element = element.parentElement;
      }
      var match = attributeValues(reflex).find(function (reflex) {
        return reflex.split("->")[0] === event.type;
      });
      if (match) {
        event.preventDefault();
        event.stopPropagation();
        this.stimulate(match.split("->")[1], element);
      }
    }
  });
  if (!controller.reflexes) Object.defineProperty(controller, "reflexes", {
    get: function get() {
      return new Proxy(reflexes, {
        get: function (target, prop) {
          var _this7 = this;
          if (prop === "last") return this.lastReflex;
          return Object.fromEntries(Object.entries(target[prop]).filter(function (_ref8) {
            var _ref9 = _slicedToArray(_ref8, 2),
              _ = _ref9[0],
              reflex = _ref9[1];
            return reflex.controller === _this7;
          }));
        }.bind(this)
      });
    }
  });
  scanForReflexesOnElement(controller.element, controller);
  emitEvent("stimulus-reflex:controller-registered", {
    detail: {
      controller: controller
    }
  });
};
var useReflex = function useReflex(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  register(controller, options);
};
document.addEventListener("cable-ready:after-dispatch-event", routeReflexEvent);
document.addEventListener("cable-ready:before-inner-html", beforeDOMUpdate);
document.addEventListener("cable-ready:before-morph", beforeDOMUpdate);
document.addEventListener("cable-ready:after-inner-html", afterDOMUpdate);
document.addEventListener("cable-ready:after-morph", afterDOMUpdate);
document.addEventListener("readystatechange", function () {
  if (document.readyState === "complete") {
    scanForReflexes();
  }
});
var StimulusReflex = Object.freeze({
  __proto__: null,
  StimulusReflexController: StimulusReflexController,
  initialize: initialize,
  reflexes: reflexes,
  register: register,
  scanForReflexes: scanForReflexes,
  scanForReflexesOnElement: scanForReflexesOnElement,
  useReflex: useReflex
});
var global = _objectSpread(_objectSpread({
  version: packageInfo.version
}, StimulusReflex), {}, {
  get debug() {
    return Debug$1.value;
  },
  set debug(value) {
    Debug$1.set(!!value);
  },
  get deprecate() {
    return Deprecate.value;
  },
  set deprecate(value) {
    Deprecate.set(!!value);
  }
});
window.StimulusReflex = global;
export { StimulusReflexController, global as default, initialize, reflexes, register, scanForReflexes, scanForReflexesOnElement, useReflex };